import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';

export default function ConceptSponsorsReducer(
  state: ContractState | undefined,
  _action: Action
): ContractState {
  return state ?? ContractUnloadState;
}
